import { render, staticRenderFns } from "./ShipmentUpload.vue?vue&type=template&id=37415525"
import script from "./ShipmentUpload.vue?vue&type=script&lang=js"
export * from "./ShipmentUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports